<template>
  <div class="message-history">
    <b-button
      v-b-modal.modal-1
      variant="primary"
      class="message-history__modal-button"
      size="sm"
      >History</b-button
    >
    <b-modal id="modal-1" size="xl" title="Message History">
      <b-table responsive striped hover :items="globalHistory" :fields="fields">
        <template v-slot:cell(description)="row">
          {{ row.item.description }}
        </template>
        <template v-slot:cell(created_at)="row">
          {{ row.item.created_at | formatDate }}
        </template>
      </b-table>
      <template #modal-footer="{ ok }">
        <b-button
          variant="success"
          class="message-history__close-button pb-2"
          @click="ok()"
        >
          Close
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      sortBy: "created_at",
      item: null,
      fields: ["haul_id", "description", "created_at"],
      globalHistory: []
    };
  },
  async created() {
    let info = {};
    if (this.$route.params.pathName === "unknown") {
      let quoteId = this.$route.params.id;
      info.messageId = quoteId;
    } else {
      this.item = this.$store.getters["quotes/quote/showQuoteById"];
      info.messageId = this.item.message.id;
    }
    let response = await this.$store.dispatch(
      "quotes/quote/getMessageHistory",
      info
    );
    this.globalHistory = response.data;
  }
};
</script>

<style lang="scss" scoped>
.message-history {
  &__modal-button {
    margin-right: 10px;
    @include primary-button;
  }
  &__close-button {
    @include primary-button;
  }
}

.modal-header {
  text-align: center;
}
</style>
